import { type FC, type ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import AuthContext from '@/contexts/authentication/auth-context';
import getCookieToken from '@/hooks/get-cookie-token';
import useGetMe from '@/hooks/use-get-me';
import showToast from '@/utils/helpers/show-toast';

interface AuthContentProviderProps {
  children: ReactNode;
}

const AuthContentProvider: FC<AuthContentProviderProps> = ({ children }) => {
  const { t } = useTranslation();
  const { data: user, isLoading, isError } = useGetMe();

  const token = getCookieToken('status');

  if (token === 'failed') {
    showToast({
      options: {
        duration: 3000,
        id: 'authentication-failed',
        classNames: {
          toast: '-mb-6!',
        },
      },
      variant: 'error',
      title: t('errors.auth.failed'),
    });
  }

  const value = useMemo(
    () => ({
      user,
      isError,
      userRoles: user?.roles || [],
      isAuthenticated: !!user && !isError,
      isLoading,
    }),
    [user, isLoading, isError]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContentProvider;
